import {axiosInstanceWithToken}  from "../utils/Client";


export default class ComplianceAuditService {
    // get audite category list (master list)
    static getAuditCategoryList = (locationId) => {
        return axiosInstanceWithToken.get(`/audit/categories/${locationId}/`);
    };

    // get audit item list of a category
    static getAuditItemList = (categoryId) => {
        return axiosInstanceWithToken.get(`/audit/item/list/${categoryId}/`);
    };

    // Add a new audit item in master list
    static AddAuditItem = (itemObj, categoryId) => {
        return axiosInstanceWithToken.post(`/audit/item/list/${categoryId}/`, itemObj);
    };

    // update an audit item in master list
    static updateAuditItem = (itemObj) => {
        return axiosInstanceWithToken.put(`/audit/item/edit/${itemObj.id}/`, itemObj);
    };

    // delete an item from from audit item list
    static deleteAuditItem = (itemId) => {
        return axiosInstanceWithToken.delete(`/audit/item/edit/${itemId}/`);
    };
    
    //Function to get category and their respective Items
    static getCategoryAndItems = (locationId) => {
        return axiosInstanceWithToken.get(`/audit/category/list/${locationId}/`);
    };

    //Function to get Items alloted to users
    static getItemsAllotedToUser = (compId, kpiId) => {
        return axiosInstanceWithToken.get(`/audit/${compId}/${kpiId}`);
    };

    //Function to create/update Items alloted to users
    static sendItemsAllotedToUser = (requestObject, compId, kpiId) => {
        
        return axiosInstanceWithToken.put(`/audit/${compId}/${kpiId}/`, requestObject);
    };

    static isCompReviewDeletionAllowed = (catId,compId, kpiId) => {
        return axiosInstanceWithToken.get(`/audit/is_allowed_to_delete_comp_review/${compId}/${kpiId}/${catId}`);
    };

    //Function to get Items alloted to users
    static getAuditPrint = (compId,kpiId , printType, auditId='') => {
        return axiosInstanceWithToken.get(
            `/audit/print/${compId}/${kpiId}/${printType}/?audit_id=${auditId}`
        );
    };
    
    // get audit form data
    static getAuditForm = (compId,kpiId, auditId='') => {
        return axiosInstanceWithToken.get(
            `/audit/response/${compId}/${kpiId}/?audit_id=${auditId}`
        );
    };

    static getFormData = (obj) => {
        const formData = new FormData();
        if (typeof obj === 'object'){     
            formData.append('form_file', obj); 
        }
        
        return formData;
      };
    
    // update audit form data
    static fileuploadAuditForm = (compId,responseList, id)  => { 
        const  responselist = ComplianceAuditService.getFormData(responseList);
        return axiosInstanceWithToken.put(
            `/audit/upload/${compId}/${id}/`, responselist
        );       
    };
    static DownloadPDF = async (file_name) => {
        return await axiosInstanceWithToken.get(
            `/audit/download/?file_name=${file_name}`, {
                responseType: 'blob'
            }
        );
    };

    static updateAuditForm = (compId, kpiId,responseList, auditId='') => {
        return axiosInstanceWithToken.put(
            `/audit/response/edit/${compId}/${kpiId}/?audit_id=${auditId}`, responseList
        );
    };

    // get audit response pdf
    static getAuditResponsePDF = (compId, auditId='') => {
        return axiosInstanceWithToken.get(
            `/audit/response/print/${compId}/?audit_id=${auditId}`
        );
    };

    // get archived audits
    static getArchivedAudits = (userId) => {
        return axiosInstanceWithToken.get(`/audit/archived/list/${userId}/`);
    };

    static isAuditedDeletion= (userId) => {
        return axiosInstanceWithToken.get(`/audit/archived/list/${userId}/`);
    };

    static getUserList = async (locationId,compId, kpiId) => {
        return await axiosInstanceWithToken.get(`audit/users_for_copy/compliance_itemlist/${locationId}/?comp_id=${compId}&kpi_id=${kpiId}`);
    };

    
    static updateSelectedItemsToAllUsers = async(settingData) => {
        return await axiosInstanceWithToken.post(
            `/audit/update_selected_items_to_allUsers/`, settingData
        );
    };

    static deleteAuditResponse = (data) => {
        return axiosInstanceWithToken.put(`/audit/response/delete/`, data);
    };

    static getCompProfileList = (userId,compId, kpiId) => {
        return axiosInstanceWithToken.get(`/audit/comp_list/${userId}/?comp_id=${compId}&kpi_id=${kpiId}`);
    };
    

};


// WEBPACK FOOTER //
// ./src/services/ComplianceAuditService.js